export const user_agreement_data = `<h1>心盒共创平台服务条款<o:p></o:p></h1><p><o:p>&nbsp;</o:p></p><p>更新日期：2022年07月04日<o:p></o:p></p><p>生效日期：2022年07月04日<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p>欢迎使用上海心盒科技有限公司（下称“上海心盒科技”）为您提供的心盒共创平台或服务。请您（下列简称为“用户”）仔细阅读以下全部内容（<b>特别是粗体标注的内容</b>）。<b>如用户未满</b><b>16</b><b>周岁，</b><b>或存在其他不具备与用户行为相适应的民事行为能力的情形，请用户在监护人的陪同下阅读本条款，并确保监护人同意其所有行为，在此情况下，用户及用户的监护人应依照法律规定承担同意本服务条款及使用心盒共创平台或服务而导致的一切后果。如用户对本条款的任何内容表示异议，或者无法准确理解本条款，请不要注册、登录心盒共创平台或使用心盒共创平台服务。如用户使用心盒共创平台或服务，即表示用户与上海心盒科技已达成协议，自愿接受本条款所有内容。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><h2>1、服务条款的确认和接纳<o:p></o:p></h2><p>本条款是用户与上海心盒科技之间关于用户使用心盒共创平台或服务的条款，内容包括条款正文、《心盒共创平台隐私政策》及上海心盒科技已经发布的或将来可能发布/更新的各类规则。所有规则为本条款不可分割的组成部分，与条款正文具有同等法律效力。除另行明确声明外，用户使用心盒共创平台或服务的行为将受本条款约束。<o:p></o:p></p><p>本条款如由于心盒共创平台发展需要进行修订的，上海心盒科技将在心盒共创平台平台公布。用户可前往查阅最新版协议条款。<b>在上海心盒科技修改上述条款后，如果用户不接受修改后的条款，用户可以选择终止使用心盒共创平台或服务。用户继续使用的，将被视为已接受了修改后的条款。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><h2>2、心盒共创平台简介<o:p></o:p></h2><p>本条款所称的“心盒共创平台”是指上海心盒科技所有和经营的产品，致力于为用户打造<u>一个体验各类型产品、了解品牌方的体验式营销</u>服务。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><h2>3、账号管理规则<o:p></o:p></h2><p>3.1 用户通过心盒共创平台可获取心盒共创平台上的内容，并可在登录后享受更为完整的服务。用户登录帐号可以是用户本人的手机号、微信号或心盒共创平台增加的其他可登录帐号。如用户通过第三方账号登录心盒共创平台的，其登录和使用行为同样适用本条款。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><b>3.2 </b><b>用户使用的心盒共创平台登录账号是上海心盒科技确认用户身份的唯一依据，用户应维持帐号及密码的机密安全，并对该账号进行的所有活动和行为负责，禁止赠与、借用、租用、转让或售卖账号。如果用户未保管好自己的帐号和密码而对用户、上海心盒科技或第三方造成损害，用户将负全部责任。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，有义务立即通告上海心盒科技。</b><b><o:p></o:p></b></p><p><b>如上海心盒科技发现或者有合理理由认为账号使用者并非该帐号初始注册人，为保障帐号安全，上海心盒科技有权立即暂停或终止为该帐号提供服务，并有权封禁或注销、回收该帐号，由此带来的包括但不限于通讯中断、资料和虚拟财产清空等损失由该账号使用人、注册人自行承担。</b><b><o:p></o:p></b></p><p><b><o:p>&nbsp;</o:p></b></p><p><b>3.3 </b><b>用户应在心盒共创平台官方渠道注册账号。用户不得恶意注册帐号（包括但不限于频繁注册、批量注册、使用他人身份注册、恶意利用或破坏心盒共创平台注册系统注册账号等）。任何通过非心盒共创平台官方途径获得的账号（包括但不限于购买、借用、租用、分享等方式获得的账号），恶意注册获得的账号，上海心盒科技有权进行封禁、注销或回收，如发生任何损失的，用户自行承担全部责任。</b><o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><b>3.4 </b><b>为符合相关法律法规的要求，保障用户的账号安全，上海心盒科技可能会对用户的身份进行验证，包括但不限于要求输入验证码、扫描二维码、手机号认证、邮箱认证等。如用户无法完成验证或拒绝验证的，上海心盒科技可合理怀疑用户的账号存在安全风险，暂停向用户提供部分或全部服务，并有权采取进一步措施。</b><b><o:p></o:p></b></p><p><b><o:p>&nbsp;</o:p></b></p><p><b>3.5 </b><b>在法律法规允许的范围内，用户同意心盒共创平台账号所有权，以及与注册、使用心盒共创平台帐号相关的服务数据和记录，包括但不限于所有注册、登录、消费记录和相关的使用统计数据，归上海心盒科技所有。发生争议时，用户同意以上海心盒科技的系统数据为准，上海心盒科技应保证该数据的真实性。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><p>3.6 用户在使用心盒共创平台服务时填写、登录、使用的帐号名称、头像、个人简介等帐号信息资料应遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在帐号信息资料中出现违法和不良信息，不得冒用、关联机构或社会名人或采取其他足以让人引起混淆的方式注册账号。且用户保证在填写、登录、使用帐号信息资料时，不得有以下情形：<o:p></o:p></p><p>（1）反对宪法所确定的基本原则的；<o:p></o:p></p><p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<o:p></o:p></p><p>（3）损害国家荣誉和利益的；<o:p></o:p></p><p>（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<o:p></o:p></p><p>（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<o:p></o:p></p><p>（6）煽动民族仇恨、民族歧视，破坏民族团结的；<o:p></o:p></p><p>（7）破坏国家宗教政策或违反国家宗教相关法律法规，宣扬邪教和封建迷信的；<o:p></o:p></p><p>（8）散布谣言，扰乱经济秩序和社会秩序的；<o:p></o:p></p><p>（9）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<o:p></o:p></p><p>（10) 侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；<o:p></o:p></p><p>（11) 含有法律、行政法规禁止的其他内容的。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p><b>3.7 </b><b>若用户在注册和使用心盒共创平台账号时，存在任何违反法律法规或不符合本条款规定之行为，心盒共创平台有权不予注册；已经注册的，上海心盒科技有权不通知用户而单方采取限期改正、短期封禁、永久封禁、注销、收回账号等措施，并有权向政府主管部门进行报告。</b><b><o:p></o:p></b></p><p>&nbsp;<o:p></o:p></p><p><b>3.8 </b><b>用户充分理解并同意：在使用心盒共创平台服务过程中，上海心盒科技可能会向用户展示上海心盒科技或其合作伙伴提供的广告或其他商业信息。上海心盒科技将按照法律规定履行广告及推广相关义务，用户应当自行判断该等信息的真实性和可靠性并为自己的判断行为负责。除法律法规明确规定外，用户因该等信息进行的购买或交易或因前述内容遭受的损害或损失，用户应自行承担，上海心盒科技不予承担责任。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><p>3.9 上海心盒科技也为用户提供账号注销功能。用户可以登录心盒共创平台，点击联系我们-联系心愿盒客服，并按照客服提示进行相应的操作。<o:p></o:p></p><p>在您的心盒共创平台账号注销之后，我们将停止为您提供心盒共创平台服务，请您谨慎操作。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><h2>4、服务的变更或中止<o:p></o:p></h2><p>上海心盒科技始终在不断变更和改进服务。<b>上海心盒科技根据自身商业决策、政府行为、不可抗力等原因可能会选择升级、变更、中止、中断及终止心盒共创平台的部分或全部服务。如有此等情形发生，上海心盒科技会采取公告的形式通知用户，但不承担由此对用户造成的任何损失。除法律法规另有明确规定的情形外，心盒共创平台有权不经用户申请，直接向用户退还尚未履行的服务所对应的费用；如用户在心盒共创平台产生收益，心盒共创平台有权不经用户申请，直接按照相关规则为用户办理收益的提现。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><h2>5、用户隐私制度<o:p></o:p></h2><p><b>尊重用户隐私是上海心盒科技的一项基本政策。上海心盒科技将按照《心盒共创平台隐私政策》收集、存储、使用、披露和保护用户的个人信息。请用户完整阅读上述隐私政策，以帮助用户更好地保护个人信息。未满十六周岁的用户，请务必在使用心盒共创平台服务、提交个人信息之前，寻求监护人的同意和指导。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><h2>6、责任限制<o:p></o:p></h2><p><b>6.1 </b><b>用户理解并同意：关于心盒共创平台服务，上海心盒科技不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。用户应对本服务的使用行为自行承担相应风险。</b><b><o:p></o:p></b></p><p><b><o:p>&nbsp;</o:p></b></p><p><b>6.2 </b><b>用户在使用心盒共创平台服务中发布的任何内容、信息等并不反映或代表上海心盒科技的观点、立场或政策，上海心盒科技对此不承担任何责任。用户应对其他用户的内容自行加以判断，并承担因使用该内容而给自己、他人及社会造成的一切法律责任，包括但不限于因对内容的准确性、真实性、完整性或实用性等的依赖而产生的风险。</b><b><o:p></o:p></b></p><p><b><o:p>&nbsp;</o:p></b></p><p><b>6.3 </b><b>用户因系统停机维护、升级、调整，第三方原因如电信部门的通讯设备故障、计算机病毒或黑客攻击、技术问题、网络、电脑故障、系统不稳定性、台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制及其他各种不可抗力原因而遭受的一切损失，上海心盒科技不承担责任；上海心盒科技对所有服务将尽力维护其安全性及方便性，但对服务中出现的信息（包括但不限于用户发布的信息）删除或储存失败不承担任何责任。因技术故障等不可抗事件影响到服务的正常运行的，上海心盒科技承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，上海心盒科技不承担责任。</b><b><o:p></o:p></b></p><p><b>&nbsp;<o:p></o:p></b></p><p><b>6.4 </b><b>任何情况下，上海心盒科技均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害承担责任。除法律法规另有明确规定外，上海心盒科技对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用心盒共创平台而支付给上海心盒科技的费用（如有）。</b><b><o:p></o:p></b></p><p><b><o:p>&nbsp;</o:p></b></p><p><b>6.5 </b><b>为保证产品、服务的安全性及产品功能的一致性，上海心盒科技可能会对心盒共创平台进行更新。用户应将软件更新到最新版本，如用户未及时更新到最新版本，上海心盒科技不保证用户一定能正常使用心盒共创平台服务。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><h2>7、禁止服务的商业化<o:p></o:p></h2><p>用户承诺，非经上海心盒科技同意，用户不能利用心盒共创平台或服务进行销售或其他商业用途。如用户有需要将心盒共创平台或服务用于商业用途，应书面通知上海心盒科技并获得上海心盒科技的明确授权。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><h2>8、用户管理<o:p></o:p></h2><p><b>8.1 </b><b>用户独立承担其在心盒共创平台所发布内容的责任。用户对心盒共创平台或服务的使用必须遵守所有适用于服务的地方法律、国家法律和国际法律。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><p>8.2 用户在心盒共创平台上发布信息或者使用心盒共创平台的软件或服务时必须符合中国有关法律法规，不得利用心盒共创平台或服务制作、复制、发布、传播法律、行政法规禁止的信息。用户同意并承诺不得制作、复制、发布含有下列内容的信息：<o:p></o:p></p><p>（1）反对宪法所确定的基本原则的；<o:p></o:p></p><p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<o:p></o:p></p><p>（3）损害国家荣誉和利益的；<o:p></o:p></p><p>（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<o:p></o:p></p><p>（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<o:p></o:p></p><p>（6）煽动民族仇恨、民族歧视，破坏民族团结的；<o:p></o:p></p><p>（7）破坏国家宗教政策或违反国家宗教相关法律法规，宣扬邪教和封建迷信的；<o:p></o:p></p><p>（8）散布谣言，扰乱经济秩序和社会秩序的；<o:p></o:p></p><p>（9）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<o:p></o:p></p><p>（10)侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；<o:p></o:p></p><p>（11)炒作绯闻、丑闻、劣迹等的；<o:p></o:p></p><p>&nbsp;（12)不当评述自然灾害、重大事故等灾难的；<o:p></o:p></p><p>（13)带有性暗示、性挑逗等易使人产生性联想的；<o:p></o:p></p><p>（14)展现血腥、惊悚、残忍等致人身心不适的；<o:p></o:p></p><p>（15)煽动人群歧视、地域歧视等的；<o:p></o:p></p><p>（16)宣扬低俗、庸俗、媚俗内容的；<o:p></o:p></p><p>（17)可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；<o:p></o:p></p><p>（18)散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；<o:p></o:p></p><p>（19)所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；<o:p></o:p></p><p>（20)所发表的信息由其他平台、其他用户创作，而非用户原创；<br/></p><p>（21)其他违反法律、行政法规规定、对网络生态造成不良影响或干扰心盒共创平台正常运营的内容。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p>8.3 用户不得利用基于深度学习、虚拟现实等的新技术新应用制作、发布、传播虚假新闻信息。用户在发布或传播利用基于深度学习、虚拟现实等的新技术新应用制作的非真实音视频信息时，应当以显著方式予以标识。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p>8.4 用户在心盒共创平台上发布信息或者利用心盒共创平台的软件或服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p>8.5 用户不得利用心盒共创平台或服务实施以下行为：<o:p></o:p></p><p>（1）通过非上海心盒科技开发、授权或认可的第三方兼容软件、系统登录或使用心盒共创平台或服务，或针对心盒共创平台和相关服务使用非上海心盒科技开发、授权或认证的插件；<o:p></o:p></p><p>（2）删除心盒共创平台及其他副本上所有关于版权的信息、内容；<o:p></o:p></p><p>（3）对心盒共创平台进行反向工程、反向汇编、反向编译或以其他方式自心盒共创平台获取源代码等；<o:p></o:p></p><p>（4）对于心盒共创平台相关信息等，未经上海心盒科技同意，擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助心盒共创平台发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；<o:p></o:p></p><p>（5）对使用心盒共创平台或服务过程中释放到任何计算机或移动终端内存中的数据及软件运行过程中客户端与服务器端的交互数据进行复制、更改、修改；<o:p></o:p></p><p>（6）通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等违背心盒共创平台提供服务的初衷的方式）使用心盒共创平台和服务；<o:p></o:p></p><p>（7）滥用心盒共创平台或服务，包括但不限于利用心盒共创平台或服务进行侵害他人知识产权或者合法利益；<o:p></o:p></p><p>&nbsp;（8）其他以任何不合法的方式、为任何不合法的目的、或以任何与本条款不一致的方式使用心盒共创平台和服务。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p>8.6 用户应遵守上海心盒科技的所有其他规定和程序。用户须对自己在使用心盒共创平台或服务过程中的行为承担法律责任。<b>用户理解并同意，若用户违反以上任何规定，上海心盒科技有权作出独立判断立即暂停或终止对用户提供部分或全部服务，包括禁言、封禁用户账号、注销用户账号等措施，用户应自行承担自身损失（包括但不限于账户资料及虚拟财产清空等）以及一切相应法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在上海心盒科技首先承担了因用户的行为导致的行政处罚或侵权损害赔偿责任后，用户应给予上海心盒科技等额的赔偿。</b><b><o:p></o:p></b></p><p><b>用户理解，如果上海心盒科技发现用户发布的信息属于上述条款所列违规内容之一，依据相关法律规定，上海心盒科技有义务立即停止传输，保存有关记录，向国家有关机关报告。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><h2>9、通知<o:p></o:p></h2><p>所有发给用户的通知都可通过电子邮件、常规的信件或在心盒共创平台内显著位置公告的方式进行传送。上海心盒科技将通过上述方法之一将消息传递给用户，告知他们服务条款的修改、服务变更、或其它重要事情。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><h2>10、内容、商标所有权<o:p></o:p></h2><p>心盒共创平台或服务提供的内容包括但不限于<u>产品测评、产品体验测试、体验分享及产品购买</u>等。除涉及第三方授权的软件、技术及内容外，所有这些内容均属于上海心盒科技，并受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护。所以，用户只能在上海心盒科技授权下才能使用这些内容，未经上海心盒科技书面同意，用户不能为任何营利或非营利性的目的擅自复制、再造这些内容、或创造与内容有关的派生产品、或以转让、许可的方式授权第三方实施、利用和转让上述知识产权。<o:p></o:p></p><p>上海心盒科技有权在服务中或经过服务在心盒共创平台中投放各种广告和宣传信息。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><h2>11、信息储存及相关知识产权<o:p></o:p></h2><p><b>上海心盒科技对心盒共创平台上所有服务将尽力维护其安全性及方便性，但对服务中出现的信息（包括但不限于用户发布的信息、用户自主创立的心愿单）删除或储存失败不承担任何责任。另外上海心盒科技有权判定用户的行为是否符合本条款的要求，如果用户违背了本条款的规定，上海心盒科技有权中止或者终止对提供其心盒共创平台服务。</b><b><o:p></o:p></b></p><p><b>对于用户在心盒共创平台发布、上传的内容（包括但不限文字、图像、音频、视频等各种形式的内容及其中包括的声音、台词、视觉设计、对话等所有组成部分，简称“用户内容”），用户应确保用户内容均为其原创或其已获得合法授权。上海心盒科技尊重知识产权并注重保护用户对其用户内容享有的各项权利。用户仍享有此等用户内容的完整知识产权，并不因向上海心盒科技提供而受到任何减损。</b><b><o:p></o:p></b></p><p><b>&nbsp;</b><b>除非有相反证明，用户知悉、理解并同意，为使用户内容得到更好的分享及推广，提高其传播价值及影响力，用户在提供此等用户内容时即授予上海心盒科技一项全球性的免费许可，允许上海心盒科技使用、传播、复制、修改、汇编、改编、翻译、创建衍生作品、出版、表演、展示、广播用户内容，以及允许上海心盒科技再许可第三方（可多层次许可）按照上述方式使用用户内容，如用户内容可供其他用户、上海心盒科技及其合作方在心盒共创平台的软件、服务或在与上海心盒科技自身及其合作方的宣传推广活动中使用。为免疑义，用户理解并同意，上述许可包括使用、复制和展示用户内容中受保护的个人形象、肖像、姓名、商标、品牌、名称、标识和公司标记（如有）及任何其他品牌、营销或推广资产、物料、素材等的权利和许可。</b><b><o:p></o:p></b></p><p><o:p>&nbsp;</o:p></p><h2>12、法律<o:p></o:p></h2><p>本条款适用中华人民共和国的法律，并且排除一切冲突法规定的适用。<o:p></o:p></p><p>如您在使用本条款项下服务中出现纠纷的，您同意将纠纷交由上海国际仲裁院仲裁解决；仲裁裁决是终局的，对双方都有约束力。仲裁费用、律师费用、财产保全费用等由败诉一方承担。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><h2>13、其他<o:p></o:p></h2><p>用户可通过本条款文末列明的客服邮箱投诉、举报各类违法违规行为，上海心盒科技将及时受理和处理用户的投诉举报。<o:p></o:p></p><p><b>心盒共创平台中的部分内容为用户自行上传，上传者对所上传的内容自行承担责任。</b>如您认为心盒共创平台上的内容侵犯您的合法权益，可通过本条款文末列明的客服邮箱向上海心盒科技提供以下文件或信息。上海心盒科技会在收到上述文件或信息后经判断决定是否对涉嫌侵权的内容或链接进行处理：<o:p></o:p></p><p>（1）要求处理的内容或链接<o:p></o:p></p><p>（2）身份证明材料<o:p></o:p></p><p>（3）联系方式和地址<o:p></o:p></p><p>（4）可证明对内容享有权利的文件。<o:p></o:p></p><p>除非另有证明，上海心盒科技储存在其服务器上的数据是用户使用心盒共创平台或服务的唯一有效证据。<o:p></o:p></p><p>本条款自发布之日起实施，并构成用户和上海心盒科技之间的共识。上海心盒科技不行使、未能及时行使或者未充分行使本条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响上海心盒科技在将来行使该权利。<o:p></o:p></p><p>如果用户对本条款内容有任何疑问，请发送邮件至我们的客服邮箱：<u>info@xinhekeji.net</u>。<o:p></o:p></p><p><o:p>&nbsp;</o:p></p><p>













































































































































































































































































</p><p>上海心盒科技<o:p></o:p></p>`